import moment from 'moment';
import { getAppLocale } from "../../../shared/helpers/date-helper/DateFormats";

export const getDate = (date: Date, format: string) => {
    return moment(date).format(format);
}

export const getTimePassedFromDate = (date: Date) => {
    return moment.utc(new Date().getTime() - new Date(date).getTime()).format('HH:mm:ss');
}

export const getTime = (date: Date) => {
    const locale = getAppLocale();
    return moment(date).locale(locale).format('LT');
}